import React, { useMemo } from 'react';
import { Tag } from 'antd';
import useCategoryStore from '../store/useCategoryStore';

const CATEGORY_COLORS = {
    'New': '#52c41a',
    'Used': '#faad14',
    'Default': '#8c8c8c'
};

const CategoryTag = ({ category, label, category_label, category_id }) => {
    const { categories } = useCategoryStore();

    // Find category in store if ID provided
    const storeCat = useMemo(() => {
        if (!category_id) return null;
        return categories.find(c => c.id == category_id);
    }, [category_id, categories]);

    const name = label || category_label || (storeCat && storeCat.label) || (category && category.label);

    // If we have a category_id but no category was found in store yet, show a generic tag or "Loading..." style
    if (category_id && !name) {
        return <Tag color="processing">ID: {category_id}</Tag>;
    }

    if (!name) return <Tag color="default">Uncategorized</Tag>;

    const color = (storeCat && storeCat.color) || CATEGORY_COLORS[name] || CATEGORY_COLORS['Default'];

    return <Tag color={color}>{name}</Tag>;
};

export default CategoryTag;
